import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { enableKioskLock, setKioskUnlocked } from '../utils/kioskSession';
import KioskStaffAuthDialog from '../components/KioskStaffAuthDialog';

/**
 * Abre /terminal tras validar admin/encargado (o si ya se desbloqueó en esta pestaña).
 */
export function useKioskTerminalLauncher() {
  const navigate = useNavigate();
  const [authOpen, setAuthOpen] = useState(false);

  const goToTerminal = useCallback(() => {
    setKioskUnlocked();
    enableKioskLock();
    navigate('/terminal');
  }, [navigate]);

  /** Siempre pide contraseña al abrir desde el menú (aunque la sesión del navegador siga activa). */
  const requestOpenTerminal = useCallback(() => {
    setAuthOpen(true);
  }, []);

  const authDialog = (
    <KioskStaffAuthDialog
      open={authOpen}
      onClose={() => setAuthOpen(false)}
      onSuccess={() => {
        setAuthOpen(false);
        goToTerminal();
      }}
      title="Abrir terminal de asistencia"
      description="Solo administrador o encargado puede activar la pantalla de la tablet."
    />
  );

  return { requestOpenTerminal, authDialog };
}
